import React, { useState } from "react";
import "./CeoPosts.css";
import { ceoProfile } from "../constant/ceoPosts";

const CeoPosts = () => {
  const [iframeLoaded, setIframeLoaded] = useState(false);

  return (
    <section className="py-5 ceo-posts-section" data-aos="fade-up">
      <div className="container">
        {/* Section Header */}
        <div className="row mb-4 align-items-end">
          <div className="col-lg-8">
            <div className="ceo-badge-pill">
              <i className="fa-brands fa-linkedin"></i>
              <span>LEADERSHIP &amp; PERSPECTIVES</span>
            </div>
            <h2 className="ceo-section-title">Posts from Our CEO</h2>
            <p className="ceo-section-subtitle">
              Direct perspectives, company updates, and engineering leadership insights from Deepak Keshari.
            </p>
          </div>
        </div>

        {/* CEO Profile Header Banner */}
        {/* <div className="ceo-intro-card" data-aos="fade-up">
          <div className="ceo-intro-content">
            <div className="ceo-intro-profile">
              <div className="ceo-avatar-wrapper">
                <img
                  src={ceoProfile.image}
                  alt={ceoProfile.name}
                  className="ceo-avatar-img"
                  onError={(e) => {
                    e.target.src = "./images/deepak.png";
                  }}
                />
                <span className="ceo-avatar-badge" title="LinkedIn Profile">
                  <i className="fa-brands fa-linkedin-in"></i>
                </span>
              </div>
              <div>
                <h3 className="ceo-intro-name">
                  {ceoProfile.name}
                  <i
                    className="fa-solid fa-circle-check text-primary small ml-1"
                    title="Founder & CEO"
                  ></i>
                </h3>
                <p className="ceo-intro-role">{ceoProfile.role}</p>
                <p className="ceo-intro-tagline">
                  &ldquo;{ceoProfile.bio}&rdquo;
                </p>
              </div>
            </div>
            <a
              href={ceoProfile.linkedinUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline-light rounded-pill px-4 py-2 font-weight-bold"
            >
              View Full Profile <i className="fa-solid fa-arrow-right ml-2"></i>
            </a>
          </div>
        </div> */}

        {/* Clean Responsive Live LinkedIn Feed Iframe */}
        <div className="ceo-iframe-container" data-aos="fade-up">
          {!iframeLoaded && (
            <div className="ceo-iframe-loader">
              <div className="spinner-border text-primary mr-3" role="status">
                <span className="sr-only">Loading feed...</span>
              </div>
              <span>Loading latest LinkedIn posts...</span>
            </div>
          )}
          <iframe
            src="https://widgets.sociablekit.com/linkedin-profile-posts/iframe/25714950"
            title="Posts from Our CEO - Deepak Keshari"
            className={`ceo-iframe-feed ${iframeLoaded ? "loaded" : ""}`}
            frameBorder="0"
            width="100%"
            height="850px"
            onLoad={() => setIframeLoaded(true)}
          ></iframe>
        </div>

        {/* Bottom Explore / Connect Banner */}
        <div className="ceo-explore-banner" data-aos="fade-up">
          <div className="ceo-explore-text">
            <div className="ceo-explore-icon">
              <i className="fa-brands fa-linkedin-in"></i>
            </div>
            <div>
              <h4 className="ceo-explore-heading">
                Stay connected with Deepak Keshari's latest updates
              </h4>
              <p className="ceo-explore-desc">
                Follow along on LinkedIn for continuous thoughts on technology innovation, scaling teams, and modern software engineering.
              </p>
            </div>
          </div>
          <a
            href={ceoProfile.linkedinUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="ceo-explore-btn"
          >
            <span>Visit LinkedIn Profile</span>
            <i className="fa-solid fa-arrow-right"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default CeoPosts;
